export enum RecordStatus {
    Accepted = 'Accepted',
    Assigned = 'Assigned',
    Concept = 'Concept',
    Declined = 'Declined',
    Destructed = 'Destructed',
    DraftValid = 'Draft.Valid',
    DraftInvalid = 'Draft.Invalid',
    Evaluated = 'Evaluated',
    Expired = 'Expired',
    New = 'New',
    PendingDestruction = 'PendingDestruction',
    Processing = 'Processing',
    ProcessingTransformations = 'Processing.Transformations',
    ProcessingDefinitiveStorage = 'Processing.DefinitiveStorage',
    ProcessedValid = 'Processed.Valid',
    ProcessedInvalid = 'Processed.Invalid',
    Published = 'Published',
    Rejected = 'Rejected',
    RejectedForCorrection = 'RejectedForCorrection',
    Submitted = 'Submitted',
    SubmittedForPublication = 'SubmittedForPublication',
    Suspended = 'Suspended',
    Uploaded = 'Uploaded',
    Sealed = 'Sealed',
    Requested = 'Requested',
    Received = 'Received',
    Open = 'Open',
    InDepot = 'InDepot',
    Validated = 'Validated',
    InQuarantine = 'InQuarantine',
    NotFound = 'NotFound',
    NotReceived = 'NotReceived',
    Sent = 'Sent',
    Pending = 'Pending',
    Completed = 'Completed',
    Picked = 'Picked',
    Unknown = 'Unknown',
    LabelCreated = 'LabelCreated'
}
